import { render, staticRenderFns } from "./AddInternalOrder.vue?vue&type=template&id=4095c890"
import script from "./AddInternalOrder.vue?vue&type=script&lang=js"
export * from "./AddInternalOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports